import { hasShootView } from '../../shared/scriptRows';
import { isStatusShareable, type Script } from '../../shared/types';

/** Presentation hints only. The admin API remains the authority for metadata. */
export function readEmbedContext(search: string): { embedded: boolean; theme: 'light' | 'dark' | null } {
  const query = new URLSearchParams(search);
  const embedded = query.get('osEmbed') === '1';
  const value = query.get('osTheme');
  return { embedded, theme: embedded && (value === 'dark' || value === 'light') ? value : null };
}

// Capture once so client-side navigation does not write the OS theme into the
// standalone preference when a route stops carrying the presentation hints.
export const embedContext = readEmbedContext(typeof window === 'undefined' ? '' : window.location.search);

export function resolveOsView(
  script: Pick<Script, 'id' | 'slug' | 'status' | 'doc_json' | 'template_key'>,
  search: string,
) {
  const query = new URLSearchParams(search);
  const view = query.get('osView');
  query.delete('osView');
  let path = `/admin/scripts/${encodeURIComponent(script.id)}`;
  let unavailable: string | null = null;
  if (view === 'client') {
    if (isStatusShareable(script.status)) path = `/s/${encodeURIComponent(script.slug)}`;
    else unavailable = 'Client review is unavailable while this document is a draft.';
  } else if (view === 'shoot') {
    if (hasShootView(script.doc_json, script.template_key)) path += '/interview';
    else unavailable = 'Add script rows, interview questions or shoot-visible brief fields to use shoot view.';
  }
  return { url: path + (query.size ? `?${query}` : ''), unavailable };
}
